var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSettings = function SvgSettings(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B3B73DDE-B99C-4E57-B7CA-4A2B2EBC208A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Botwise---Chatbot---Adnotacje",
    transform: "translate(-833.000000, -525.000000)",
    stroke: "#20BDA3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(834.000000, 526.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,7.95454545 L14,6.04545455 L11.9330909,5.76354545 C11.8115291,5.27845263 11.6185092,4.81413252 11.3603636,4.38581818 L12.6229091,2.72490909 L11.2750909,1.37518182 L9.61418182,2.63772727 C9.18586748,2.37958169 8.72154737,2.18656178 8.23645455,2.065 L7.95454545,0 L6.04545455,0 L5.76354545,2.06690909 C5.27845263,2.18847087 4.81413252,2.38149078 4.38581818,2.63963636 L2.72490909,1.37518182 L1.37518182,2.72490909 L2.63772727,4.38581818 C2.37958169,4.81413252 2.18656178,5.27845263 2.065,5.76354545 L0,6.04545455 L0,7.95454545 L2.06690909,8.23645455 C2.18847087,8.72154737 2.38149078,9.18586748 2.63963636,9.61418182 L1.37709091,11.2750909 L2.72681818,12.6248182 L4.38772727,11.3622727 C4.81604161,11.6204183 5.28036172,11.8134382 5.76545455,11.935 L6.04545455,14 L7.95454545,14 L8.23645455,11.9330909 C8.72154737,11.8115291 9.18586748,11.6185092 9.61418182,11.3603636 L11.2750909,12.6229091 L12.6248182,11.2731818 L11.3622727,9.61227273 C11.6204183,9.18395839 11.8134382,8.71963828 11.935,8.23454545 L14,7.95454545 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 7,
    r: 2
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Settings.22c67c572d48aea97335c88c5515d3ed.svg";